import { SelectOption } from '../../atom/Select';

export const DefaultFilterTypeObject = {
  TEXT: 'TEXT',
} as const;
export const WithOptionsFilterTypeObject = {
  SELECT: 'SELECT',
} as const;
export const ArrayFilterTypeObject = {
  DATE_RANGE: 'DATE_RANGE',
} as const;
export const PhoneFilterTypeObject = {
  PHONE: 'PHONE',
} as const;

export const ListFilterTypeObject = {
  ...DefaultFilterTypeObject,
  ...WithOptionsFilterTypeObject,
  ...ArrayFilterTypeObject,
  ...PhoneFilterTypeObject,
};

export interface DefaultFilters {
  key: string;
  label: string;
  type?: keyof typeof DefaultFilterTypeObject;
  placeholder?: string;
}

export interface WithOptionsFilterFilters {
  key: string;
  label: string;
  type: keyof typeof WithOptionsFilterTypeObject;
  options: SelectOption[];
  placeholder?: string;
}

export interface ArrayFilters {
  key: string;
  label: string;
  type: keyof typeof ArrayFilterTypeObject;
  rangeKeys?: string[];
  placeholder?: string;
}

export interface PhoneFilters {
  key: string;
  label: string;
  type?: keyof typeof PhoneFilterTypeObject;
  placeholder?: string;
}

export interface BaseFilterProps {
  title?: string;
  cols?: 1 | 2 | 3 | 4;
  filters: (
    | DefaultFilters
    | WithOptionsFilterFilters
    | ArrayFilters
    | PhoneFilters
  )[];
  onSubmit: (params: Record<string, any>) => void;
  hasQueryParams?: boolean;
}
